<ng-template #measurementDisplay let-value="value" let-icon="icon">
  <div class="measure">
    <div class="vertical-rule"></div>
    <fa-icon [icon]="icon" [fixedWidth]="true" class="icon fa-xl"></fa-icon>
    <span>
      {{ value }}
    </span>
  </div>
</ng-template>

<ng-container *ngIf="formattedMeasurement$ | async as formattedMeasurement">
  <div [ngSwitch]="formattedMeasurement.mode">
    <div *ngSwitchCase="'free-point'" class="form-control container">
      <span>Distance</span>
      <ng-template
        *ngTemplateOutlet="
          measurementDisplay;
          context: {
            value: formattedMeasurement.distance,
            icon: faDistanceFreePoint,
          }
        "
      ></ng-template>
    </div>

    <div *ngSwitchCase="'cuboid-to-sensor'" class="form-control container">
      <span>Distance</span>
      <ng-template
        *ngTemplateOutlet="
          measurementDisplay;
          context: {
            value: formattedMeasurement.distance,
            icon: faDistanceCuboidToPoint,
          }
        "
      ></ng-template>

      <ng-template
        *ngTemplateOutlet="
          measurementDisplay;
          context: { value: formattedMeasurement.angle, icon: faDegreeAngle }
        "
      ></ng-template>
    </div>

    <div *ngSwitchCase="'subpoint-height'" class="form-control container">
      <span>Distance</span>
      <ng-template
        *ngTemplateOutlet="
          measurementDisplay;
          context: {
            value: formattedMeasurement.distance,
            icon: faDistanceSubpointHeight,
          }
        "
      ></ng-template>
    </div>
  </div>
</ng-container>
